export default __webpack_public_path__ + "static/media/url-pink.b2e448eb.svg";